<template>
  <div v-if="currentTraining != null">
    <div class="row">
      <div class="col-xs-12">
        <div class="box box-solid">
          <div class="box-body">
            <div class="box-group" id="accordion">
              <div class="panel box box-primary">
                <div class="box-header with-border">
                  <h4 class="box-title">
                    <a data-toggle="collapse" data-parent="#accordion" href="#collapseOne" aria-expanded="false"
                       class="collapsed">
                      {{$t('help.title')}}
                    </a>
                  </h4>
                </div>
                <div id="collapseOne" class="panel-collapse collapse" aria-expanded="false"
                     style="height: 0px;">
                  <div v-if="$root.$i18n.locale == 'en'" class="box-body">
                    <p><b>Step 1.</b> Please, use a Calendar below to choose only the start date (the day of the
                      arrival) of the Sports Program (s).</p>

                    <p>Example (a): The program has only one available Date, March 1 - March 7. Choose March 1
                      in the Calendar.</p>

                    <p>Example (b): The program has five Dates with six days each, e.g., March 1 - March 7;
                      March 8 - March 14; March 15 - March 21; etc. Choose only start dates in the Calendar -
                      March 1, March 8, March 15, etc.</p>

                    <p>As you will see, you can add several Dates with a single iteration. But Dates must have
                      the same duration in days.</p>

                    <p>Example (с): The program has Dates with different duration - e.g., March 1- March 7; and
                      March 8 - March 24. In this case, you will have to add Dates separately and to go through
                      Steps 1 - 3 for each Date with a different duration. That is, firstly, choose March 1 in
                      the Calendar and complete/save the Date, and then do the same for March 8.</p>

                    <p>Once Date (-s) is chosen, - this Date will be highlighted in the Calendar and have
                      “minus” in the right upper corner.</p>

                    <p>If the Date (-s) is incorrect, click the “minus” and remove it.</p>

                    <p><b>Step 2.</b> There are a few other fields to fill in.</p>
                    <ul>
                      <li>“Duration” - the number of days the program’s Date (-s) consists of.</li>

                      <li>“Price” - the price of the sports program (and its respective Date(-s)). The Price
                        must not be higher than the original price of the program for which it is sold beyond
                        the platform.
                      </li>

                      <li>“Deposit” - the deposit amount the participant must pay to reserve a place in the
                        program.
                      </li>

                      <li>If you do not use Deposits, and the participant must pay the full amount at once, -
                        please, leave this field blank.
                      </li>

                      <li>“Currency” - choose the relevant currency.</li>
                    </ul>
                    <p><b>Step 3.</b> Save the Date (-s) you have just created. It will be shown on the right
                      column “Active Dates”</p>

                    <p>If there is a mistake - you can remove the wrong Date (by clicking the “x”) and redo
                      it.</p>

                  </div>
                  <div v-if="$root.$i18n.locale == 'ru'" class="box-body">
                    <p><b>Шаг 1.</b> Ниже представлен Календарь, в котором следует выбрать <u><b>только
                      начальную</b></u> дату Заезда (-ов).</p>

                    <p>Пример (а): Программа предусматривает только один заезд с 1 марта по 7 марта. В Календаре
                      выбираете <b>только</b> 1 марта.</p>

                    <p>Пример (б): Программа предусматривает 5 Заездов по 6 дней каждый с 1 марта по 6 марта, с
                      7 марта по 13 марта и т.д.. В Календаре выбираете только начальные даты Заездов - 1 марта,
                      7 марта, и т.д.</p>

                    <p>Пример (в): Программа имеет Заезды с разной продолжительностью,- скажем с 1 марта по 7
                      марта, с 8 марта по 24 марта. В данном случае, добавлять Заезды придется по очереди, то
                      есть для создания каждого пройти шаги 1-3.</p>

                    <p>Когда Дата (-ы) Заезда (-ов) выбрана - в Календаре эта дата выделится цветом и появится
                      знак “минус”.</p>

                    <p>Если Дата (-ы) указаны неверно - нажмите на “минус” и такая ошибочная дата удалится.</p>

                    <p><b>Шаг 2.</b> Ниже Календаря представлены дополнительные поля:</p>
                    <ul>
                      <li>В поле “Продолжительность” - продолжительность Заезда (-ов) в днях.</li>

                      <li>В поле “Стоимость” - стоимость программы (отдельного Заезда). Стоимость <b>должна быть
                        не выше оригинальной цены</b>, по которой данная программа “продается” за пределами
                        платформы.
                      </li>

                      <li>В поле “Предоплата” - укажите сумму депозита (предоплаты), если бронирование
                        предусматривает это. Если для бронирования места - необходимо оплатить полную стоимость
                        программы, то оставьте поле пустым.
                      </li>

                      <li>В поле “Валюта” - выберите применимую валюту.</li>
                    </ul>
                    <p><b>Шаг 3.</b> Сохраните созданный Заезд (-ы). Это будет отображено правой колонке
                      “Активные заезды”.</p>
                    <p>Если при создании Заезда (-ов) была совершена ошибка, - можно удалить (нажав на “x”) и
                      создать заново.</p>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-6">
        <div class="box box-info">
          <div class="box-header">
            <h3 class="box-title">{{$t('trainings.arrivals.added-form.title')}}</h3>
          </div>
          <div class="box-body">
            <YearCalendar
              v-model="year"
              :activeDates.sync="activeDates"
              @toggleDate="toggleDate"
              lang="en"
              :showYearSelector="showYearSelector"
            ></YearCalendar>

            <div class="box-body">
              <div class="form-group">
                <label>{{$t('trainings.arrivals.added-form.selected-date')}}</label>
                <ul>
                  <li
                    v-for="activeDate in activeDates"
                    :key="activeDate.date">
                    {{convertToDate(activeDate.date).toLocaleString($root.$i18n.locale, getDateOptions())}}
                  </li>
                </ul>
              </div>

              <div class="form-group">
                <label>{{$t('trainings.arrivals.added-form.period')}}</label>
                <input type="text" v-model="addedArrivals.countDay" class="form-control" placeholder="">
              </div>
              <div class="form-group">
                <label>{{$t('trainings.arrivals.added-form.provider-price')}}</label>
                <input type="text" class="form-control" v-model="addedArrivals.providerPrice" placeholder="">
              </div>
              <div class="form-group">
                <label>{{$t('trainings.arrivals.added-form.prepay')}}</label>
                <input type="text" class="form-control" v-model="addedArrivals.prepay" placeholder="">
              </div>
              <div class="form-group">
                <label>{{$t('trainings.arrivals.added-form.currency')}}</label>
                <select name="currency" class="form-control" v-model="addedArrivals.currency">
                  <option value="RUB">RUB</option>
                  <option value="EUR">EUR</option>
                  <option value="USD">USD</option>
                  <option value="GBP">GBP</option>
                </select>
              </div>
            </div>
            <div class="box-footer">
              <button type="submit" v-on:click="cleanArrival" class="btn btn-default">
                {{$t('button.clean')}}
              </button>
              <button type="submit" v-on:click="saveArrival" class="btn btn-info pull-right">
                {{$t('button.save-changes')}}
              </button>
            </div>
          </div>
        </div>

      </div>
      <div class="col-xs-6">
        <div class="box box-success">
          <div class="box-header">
            <h3 class="box-title">{{$t('trainings.arrivals.active-arrivals.title')}}</h3>
          </div>
          <div class="box-body table-responsive no-padding">
            <table class="table table-hover">
              <tbody>
              <tr>
                <th>{{$t('trainings.arrivals.active-arrivals.start-date')}}</th>
                <th>{{$t('trainings.arrivals.active-arrivals.end-date')}}</th>
                <th>{{$t('trainings.arrivals.active-arrivals.provider-price')}}</th>
                <th v-if="isBackoffice()">{{$t('trainings.arrivals.active-arrivals.our-price')}}</th>
                <th>{{$t('trainings.arrivals.active-arrivals.prepay')}}</th>
                <th></th>
              </tr>
              <tr
                v-for="arrival in activeSortedArrival"
                :key="arrival.id">
                <td>{{convertToDate(arrival.start).toLocaleString($root.$i18n.locale, getDateOptions())}}</td>
                <td>{{convertToDate(arrival.end).toLocaleString($root.$i18n.locale, getDateOptions())}}</td>
                <td>{{arrival.providerPrice.value}} {{arrival.providerPrice.currency.codeISO}}</td>
                <td v-if="isBackoffice()">
                  <input class="ourPriceValue"
                         v-on:keyup.enter="updateArrival(currentTraining.Id, arrival)"
                         type="text" v-model="arrival.ourPrice.value"/>
                  {{arrival.ourPrice.currency.codeISO}}</td>
                <td>{{arrival.prepay.value}} {{arrival.prepay.currency.codeISO}}</td>
                <td><a v-on:click="deleteArrival(arrival.id)"><i class="text-red fa fa-times-circle-o"></i></a>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="box">
          <div class="box-header">
            <h3 class="box-title">{{$t('trainings.arrivals.archive-arrivals.title')}}</h3>
          </div>
          <div class="box-body table-responsive no-padding">
            <table class="table table-hover">
              <tbody>
              <tr>
                <th>{{$t('trainings.arrivals.archive-arrivals.start-date')}}</th>
                <th>{{$t('trainings.arrivals.archive-arrivals.end-date')}}</th>
                <th>{{$t('trainings.arrivals.archive-arrivals.provider-price')}}</th>
                <th>{{$t('trainings.arrivals.archive-arrivals.prepay')}}</th>
              </tr>
              <tr
                v-for="arrival in archiveSortedArrival"
                :key="arrival.id">
                <td>{{convertToDate(arrival.start).toLocaleString($root.$i18n.locale, getDateOptions())}}</td>
                <td>{{convertToDate(arrival.end).toLocaleString($root.$i18n.locale, getDateOptions())}}</td>
                <td>{{arrival.providerPrice.value}} {{arrival.providerPrice.currency.codeISO}}</td>
                <td>{{arrival.prepay.value}} {{arrival.prepay.currency.codeISO}}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-default pull-left" data-dismiss="modal">{{$t('button.close')}}</button>
    </div>

    <div class="modal fade" id="modal-calendar">
      <div class="modal-dialog modal-dialog-s">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span></button>
            <h4 class="modal-title">{{$t('trainings.arrivals.added-form.calendar')}}</h4>
          </div>
          <div class="modal-body">
            <YearCalendar
              v-model="year"
              :activeDates.sync="activeDates"
              @toggleDate="toggleDate"
              lang="en"
              :showYearSelector="showYearSelector"
            ></YearCalendar>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import YearCalendar from 'vue-material-year-calendar';
import axios from 'axios';
import moment from 'moment';
import {_} from 'vue-underscore';

export default {
  name: 'TrainingArrivals',
  components: {YearCalendar},
  props: {
    currentTraining: Object
  },
  data () {
    return {
      year: 2021,
      activeDates: [],
      showYearSelector: true,
      selectedDates: [],
      addedArrivals: {}
    };
  },
  computed: {
    sortedArrivals: function () {
      var sorted = _.sortBy(this.currentTraining.arrivals, function (arrival) {
        return new Date(Date.parse(arrival.start));
      });
      return sorted;
    },
    activeSortedArrival: function () {
      var sorted = _.sortBy(this.currentTraining.arrivals, function (arrival) {
        return new Date(Date.parse(arrival.start));
      });

      sorted = _.filter(sorted, function (arrival) {
        return new Date(Date.parse(arrival.start)) >= new Date();
      });

      return sorted;
    },
    archiveSortedArrival: function () {
      var sorted = _.sortBy(this.currentTraining.arrivals, function (arrival) {
        return new Date(Date.parse(arrival.start));
      });

      sorted = _.filter(sorted, function (arrival) {
        return new Date(Date.parse(arrival.start)) < new Date();
      });

      return sorted;
    }
  },
  methods: {
    isBackoffice: function () {
      return window.application !== 'cabinet';
    },
    convertToDate: function (strDate) {
      return new Date(Date.parse(strDate));
    },
    getDateOptions: function () {
      var options = {year: 'numeric', month: '2-digit', day: '2-digit'};
      return options;
    },
    toggleDate (dateInfo) {
      console.log(dateInfo);
      this.selectedDates.push(dateInfo);
    },
    updateArrival (trainingId, arrival) {
      var self = this;
      console.log(self);

      console.log(trainingId);
      console.log(arrival);

      var savedArrival = {
        id: arrival.id,
        start: arrival.start,
        end: arrival.end,
        providerPrice: {
          value: arrival.providerPrice.value,
          currency: arrival.providerPrice.currency.codeISO
        },
        ourPrice: {
          value: arrival.ourPrice.value,
          currency: arrival.ourPrice.currency.codeISO
        },
        prepay: {
          value: arrival.prepay.value,
          currency: arrival.prepay.currency.codeISO
        },
      };

      axios.put(window.host + '/trainings/' + self.currentTraining.id + '/arrivals/' + arrival.id,
        savedArrival)
        .then(function (response) {
          console.log(response.data);
          self.$root.$emit('alert', 'success', 'alert.success');
        })
        .catch(function (error) {
          console.log(error);
          self.$root.$emit('alert', 'error', 'alert.error');
        });
    },
    deleteArrival (arrivalId) {
      let del = {
        arrivalId: arrivalId,
        trainingId: this.currentTraining.id,
      };

      let self = this;

      console.log(del);

      axios.delete(
        window.host + '/trainings/' + self.currentTraining.id + '/arrivals/' + del.arrivalId)
        .then(function (response) {
          console.log(response.data);
          self.$root.$emit('alert', 'success', 'alert.success');
          self.$root.$emit('updateTraining', del.trainingId);
        })
        .catch(function (error) {
          console.log(error);
          self.$root.$emit('alert', 'error', 'alert.error');
        });
    },
    saveArrival () {
      console.log(this.addedArrivals);
      console.log(this.activeDates);
      console.log(this.currentTraining.camp.id);

      let self = this;

      axios.get(
        window.host + '/camps/' + self.currentTraining.camp.id + '/FinincialInformation')
        .then(async function (finInfoResponse) {
          let finInfo = finInfoResponse.data;

          for (var i = 0; i < self.activeDates.length; i++) {

            var sD = moment(new Date(self.activeDates[i].date));
            var eD = moment(new Date(self.activeDates[i].date)).add(parseInt(self.addedArrivals.countDay), 'days');

            var ourPrice = self.addedArrivals.providerPrice * 0.99;

            if (finInfo != '' && self.addedArrivals.currency == finInfo.defaultCurrency.codeISO) {
              if (parseInt(self.addedArrivals.countDay) > 31 && parseInt(self.addedArrivals.countDay) <= 90) {
                ourPrice = self.addedArrivals.providerPrice - finInfo.campComission.mediumTermComission.value * 0.2;
              } else if (parseInt(self.addedArrivals.countDay) > 91) {
                ourPrice = self.addedArrivals.providerPrice - finInfo.campComission.longTermComission.value * 0.2;
              }
            }

            console.log('ourPrice ' + ourPrice);

            ourPrice = Math.floor(ourPrice);

            var arrivalResult = {
              start: sD,
              end: eD,
              providerPrice: {
                value: self.addedArrivals.providerPrice,
                currency: self.addedArrivals.currency
              },
              ourPrice: {
                value: ourPrice,
                currency: self.addedArrivals.currency
              },
              prepay: {
                value: self.addedArrivals.prepay,
                currency: self.addedArrivals.currency
              }
            };

            await getExchangeRate(self.currentTraining.id, arrivalResult);
          }

          self.$root.$emit('alert', 'success', 'alert.success');
          self.$root.$emit('updateTraining', self.addedArrivals.trainingId);
        })
        .catch(function (error) {
          console.log(error);
          self.$root.$emit('alert', 'error', 'alert.error');
        });
    },
    cleanArrival () {
      this.addedArrivals = {};
      this.activeDates = [];
    }
  }
};

const getExchangeRate = async (trainingId, arrivalResult) => {
  try {
    var response = await axios.put(
      window.host + '/trainings/' + trainingId + '/arrivals', arrivalResult);

    return response;
  } catch (error) {
    console.log(error);
    throw error;
  }
};
</script>

<style scoped>
  .modal-dialog-l {
    width: 80%;
  }
</style>
